import styled from 'styled-components';
import { AllieBadge } from '../../../components/Badge';
import { AllieCard } from '../../../components/Card';
import { AllieChip } from '../../../components/Chip';
import { AllieIconButton } from '../../../components/Buttons/IconButton';
import { AllieText } from '../../../components/Text';
import { AllieColors } from '../../../common/color.types';

export const AllieCardStyled = styled(AllieCard)`
  ion-card-header {
    padding: var(--allie-spacing-xl) var(--allie-spacing-xl) var(--allie-spacing-md)
      var(--allie-spacing-xl);

    .header-text {
      display: flex;
      flex-direction: column;
      row-gap: var(--allie-spacing-xs);
    }
  }

  ion-card-content {
    flex: 1;
  }

  .action-plan-button-container {
    display: flex;
    align-items: center;
    gap: var(--allie-spacing-xs);

    img {
      width: 20px;
      height: 20px;
      border: none;
      outline: none;
    }
  }
`;

export const ProcessVariableHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  column-gap: 12px;
`;

export const TagsRowWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--allie-spacing-xs);
`;

export const ProcessVariableContentWrapper = styled.div<{
  isMobile: boolean;
  isOutdated?: boolean;
}>`
  display: ${({ isMobile }) => (isMobile ? 'flex' : 'grid')};
  grid-template-columns: ${({ isOutdated }) => (isOutdated ? '1fr' : 'auto 1fr')};
  gap: 17px;
  width: 100%;
  height: 100%;
  flex: 1;
  align-items: center;
`;

export const StyledAllieChip = styled(AllieChip)`
  margin: 0;
  box-sizing: content-box;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 0 var(--allie-spacing-lg);
  justify-content: center;
  flex-shrink: 0;
  width: fit-content;
`;

export const StyledIconButton = styled(AllieIconButton)`
  --border-color: var(--allie-color-neutral-30) !important;
  --color: var(--allie-color-neutral-60);
  --box-shadow: none !important;
  --background: white;
  cursor: default;
  ion-spinner {
    height: 20px;
    width: 20px;
  }
`;

export const ContentOutdatedVariable = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--allie-spacing-xs);
  align-items: center;
  width: 100%;
  justify-content: center;
  justify-self: center;
  text-align: center;

  .presentation-chart-icon {
    width: 24px;
    height: 24px;
    background-color: var(--allie-color-neutral-10);
    padding: var(--allie-spacing-xl);
    border-radius: var(--allie-radius-full);
  }

  .text-outdated {
    width: 220px;
  }
`;

export const ContentProcessVariableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--allie-spacing-xs);
`;

export const AllieTextCustomValueStyled = styled(AllieText)`
  height: 100px;
  overflow: hidden;
  width: 120px;
  display: block;
  text-overflow: ellipsis;
  align-content: end;
`;

export const AllieTextValueStyled = styled(AllieText)<{ isMobile: boolean }>`
  overflow: hidden;
  white-space: nowrap;
  width: 120px;
  display: block;
  text-overflow: ellipsis;
  font-size: ${({ isMobile }) => isMobile && '24px'};
`;

export const ContentExpandedVariableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--allie-spacing-lg);
  align-self: stretch;
  flex-shrink: 0;
  min-width: 160px;
`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .header {
    margin-bottom: var(--allie-spacing-md);
  }

  .graph-container {
    margin-top: var(--allie-spacing-xl);
    width: 100%;
  }
`;

export const VariableValueContainer = styled.div<{
  $backgroundColor: AllieColors;
  $isMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-md);
  width: ${({ $isMobile }) => ($isMobile ? '100%' : 'unset')};
  height: 100%;

  .status-value-container {
    display: flex;
    padding: var(--allie-spacing-xl);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--allie-spacing-md);
    background-color: var(--allie-color-${({ $backgroundColor }) => $backgroundColor});

    .value-container {
      display: flex;
      align-items: center;
      gap: var(--allie-spacing-md);
      justify-content: flex-start;
      flex-wrap: nowrap;
    }

    &-mobile {
      background-color: var(--allie-color-${({ $backgroundColor }) => $backgroundColor});
      display: flex;
      justify-content: space-between;
      padding: var(--allie-spacing-xl);
      border-radius: var(--allie-radius-md);

      .value-container {
        display: flex;
        align-items: center;
        gap: var(--allie-spacing-md);
        justify-content: flex-start;
        flex-wrap: nowrap;
      }

      .chip-container {
        display: flex;
        flex-direction: column;
        align-items: end;
        gap: var(--allie-spacing-md);
      }
    }
  }
`;

export const StatsContainer = styled.div<{
  isMobile: boolean;
  isCustomType: boolean;
  isMetricOnOff: boolean;
}>`
  display: ${({ isCustomType, isMetricOnOff }) =>
    isCustomType || isMetricOnOff ? 'none' : 'flex'};
  flex-direction: ${({ isMobile }) => (isMobile ? 'row' : 'column')};
  gap: ${({ isMobile }) => (isMobile ? 'var(--allie-spacing-xl)' : 'var(--allie-spacing-md)')};
  margin-top: ${({ isMobile }) => isMobile && 'var(--allie-spacing-xl)'};
`;

export const StyledValue = styled(AllieText)`
  white-space: nowrap;
`;

export const ValueAndStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-md);
`;

export const ContainerProcessVariable = styled.article`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const AllieBadgeStyled = styled(AllieBadge)`
  background-color: var(--allie-color-error-main);
  color: #ffffff;
  font-size: 14px;
  margin-top: var(--allie-spacing-md);
`;
